<div class="">
<!-- container -->
    <form class="myForm" [formGroup]="createusuarioForm" (ngSubmit)="onSubmit()">
        <div class="row">

            <div class="col-lg-6">

                <div class="form-group">
                    <label for="">Nombre Proveedor</label>


                    @if(createusuarioForm.get('role').value == 'proveedor') {
                        <app-generic-dropdown [optionsLabels]="['abv','nombre', 'codigo']" [item]="myId" [database]="'wproveedores'"
                            (selectNameItem)="createusuarioForm.patchValue({nombre: $event})">
                        </app-generic-dropdown>

                    } @else {
                        <input type="text" class="form-control" formControlName="nombre">
                        <div *ngIf="createusuarioForm.controls.nombre.invalid && (createusuarioForm.controls.nombre.dirty || createusuarioForm.controls.nombre.touched)"
                            class="alert alert-danger">
                            <div *ngIf="createusuarioForm.controls.nombre.errors.required">
                                Nombre es necesario
                            </div>                        
                        </div>
                    }
                    
                </div>

                <div class="form-group">
                    <label for="">Contraseña</label>
                    <input type="text" class="form-control" formControlName="password">
                    <div *ngIf="createusuarioForm.controls.password.invalid && (createusuarioForm.controls.password.dirty || createusuarioForm.controls.password.touched)"
                        class="alert alert-danger">

                        <div *ngIf="createusuarioForm.controls.password.errors.required">
                            Password es necesario
                        </div>

                    </div>
                </div>
                <div *ngIf="false" class="form-group">
                    <label for="">Role</label>
                    <input type="text" class="form-control" formControlName="role">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="input-group mb-3" style="margin-top: 31px;
                margin-bottom: 0 !important;">
                    <div class="input-group-prepend">
                        <div class="input-group-text">
                            <label>SOLO LECTURA</label>
                            <p-inputSwitch formControlName="read_only"></p-inputSwitch>
                        </div>
                    </div>
                </div>
                <div class="input-group mb-3" style="margin-top: 34px;
                margin-bottom: 0 !important;">
                    <div class="input-group-prepend">
                        <div class="input-group-text">
                            <label>ACTIVO</label>
                            <p-inputSwitch formControlName="eliminado"></p-inputSwitch>
                        </div>
                    </div>
                </div>
                <div *ngIf="false" class="form-group">
                    <label for="">Firma</label>
                    <input type="file" class="form-control" (change)="uploadFile($event)">
                    <img [src]="imgURL" class="image_firma" *ngIf="imgURL">
                </div>
            </div>
        </div>

        <div class="botones">
            <button type="button" class="btn btn-warning" (click)="regresar()"><i class="fa fa-chevron-left"
                    aria-hidden="true"></i> Volver</button>
            <button type="submit" class="btn btn-success" [disabled]="!createusuarioForm.valid"><i class="fa fa-save"
                    aria-hidden="true"></i> Guardar</button>
        </div>
    </form>
</div>


<p-toast [style]="{marginTop: '80px'}"></p-toast>